import classNames from 'classnames';
import * as React from 'react';
import { Image } from 'palette/Image';
import { BodyText } from 'palette/Typography';
import './styles/MainHeaderDropdownItem.scss';

interface MenuItemProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
    name: string;
    url: string;
    image: string | null;
    isActive: boolean;
}

function MainHeaderDropdownItem({
    id, name, url, image, isActive, className, ...props
}: MenuItemProps) {
    const classes = classNames('header-menu-item', className);

    return (
        <a
            key={id}
            className={classes}
            href={url}
            {...props}
        >
            <Image
                alt={name}
                className="header-menu-item__image"
                height={200}
                loading="lazy"
                src={image ?? ''}
                width={200}
            />
            <BodyText
                color="strong"
                level="1"
                {...isActive && { textDecoration: 'underline' }}
            >
                {name}
            </BodyText>
        </a>
    );
}

export default MainHeaderDropdownItem;
